import axios, { AxiosHeaders, AxiosHeaderValue, InternalAxiosRequestConfig } from 'axios';

import { useAuthStore } from '@store/auth';

export const paymentAPI = axios.create({
  baseURL: process.env.REACT_APP_PAYMENT_API_ENDPOINT,
});

function mergeHeaders(config: InternalAxiosRequestConfig, headersConfig: Record<string, AxiosHeaderValue>) {
  const headers = AxiosHeaders.from(config.headers);
  Object.entries(headersConfig).forEach(([key, value]) => {
    headers.set(key, value);
  });
  config.headers = headers;
}

export function invoiceAPI(headersConfig: Record<string, AxiosHeaderValue> = {}) {
  const api = axios.create({
    baseURL: process.env.REACT_APP_INVOICE_API_BASE_URL,
  });

  api.interceptors.request.use(async (config) => {
    const bearerToken = await useAuthStore.getState().getBearerToken();

    const headers = AxiosHeaders.from(config.headers);

    if (bearerToken) {
      headers.set('Authorization', bearerToken);
    }

    Object.entries(headersConfig).forEach(([key, value]) => {
      headers.set(key, value);
    });

    config.headers = headers;
    return config;
  });

  return api;
}

export function publicAPI(headersConfig: Record<string, AxiosHeaderValue> = {}) {
  const api = axios.create({
    baseURL: process.env.REACT_APP_INVOICE_API_BASE_URL,
  });

  api.interceptors.request.use((config) => {
    mergeHeaders(config, headersConfig);
    return config;
  });

  return api;
}

export function invoiceAdminAPI(healthEntity = '', headersConfig: Record<string, AxiosHeaderValue> = {}) {
  const api = axios.create({
    baseURL: process.env.REACT_APP_INVOICE_API_BASE_URL,
  });

  const cookieValue = document.cookie
    .split('; ')
    .find((row) => row.startsWith('AccessToken='))
    ?.split('=')[1];

  api.interceptors.request.use((config) => {
    const headers = AxiosHeaders.from(config.headers);

    if (healthEntity) {
      headers.set('healthEntity', healthEntity);
    }

    Object.entries(headersConfig).forEach(([key, value]) => {
      headers.set(key, value);
    });

    config.headers = headers;
    return config;
  });

  return api;
}

export function publicExternalAPI(url: string, headersConfig: Record<string, AxiosHeaderValue> = {}) {
  const api = axios.create({
    baseURL: url,
  });

  api.interceptors.request.use((config) => {
    mergeHeaders(config, headersConfig);
    return config;
  });

  return api;
}
